<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3" v-if="!isFromDashBoard">{{'Download History'}}</strong>
          <h4  class="card-title m-0 float-left" v-if="isFromDashBoard">{{'Download History'}}</h4>
        </div>
        <div class="col-md-1" v-if="!isFromDashBoard">
          <download :tableId="'download-history'" :fileName="'download-history'"></download>
        </div>
        <div class="col-md-1" v-if="!isFromDashBoard">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive app" v-dragscroll="true">
        <table id="download-history" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td >
                <span v-if="!isFromDashBoard">{{(index+1)+(perPage*($refs.page.current_page-1))}}</span>
                <span v-else>{{(index+1)}}</span>
                </td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='date'">{{getDateTime(row[field.name])}}</span>
                <span v-else-if="field.name==='userid'">{{row[field.name][0]}}</span>
                <span v-else-if="field.name==='first_name'">{{row[field.name][0]}} {{row['last_name'][0]}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+actions.length+1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <pagination v-if="!isFromDashBoard" ref="page" :pageName="pageType" :totPages="totalPages" :apiUrl="apiUrl" @changePage="pageChange"></pagination>
        <div class="pull-right" v-if="isFromDashBoard">
          <router-link class="page-link" :to="'/activity-logs/download-history'">
            View All
          </router-link>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";


export default {
  mixins: [commonMixins],
  name: "getDownload",
  props: ["isFromDashBoard"],
  created() {
    console.log("Config ", process.env.API_URL);
    // this.url = this.apiUrl;
    // console.log(this.url.indexOf("user-activity"), this.$route.query);
    // this.$route.query.page
    //   ? (this.pageToLoad = parseInt(this.$route.query.page))
    //   : (this.pageToLoad = "1");
    // this.url += this.pageToLoad;
    // this.current_page = this.pageToLoad;
    if(this.isFromDashBoard){
      this.url = this.apiUrl+this.page;
    }
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    // $route(to, from) {
    //   this.page = to.query.page;
    //   this.url = this.apiUrl+this.page;
    //   console.log("watch route", to.query);
    //   // this.fetchData(to.query)
    // }
  },
  data() {
    return {
      apiUrl: "getDownload/",
      pageType: 'user-activity',
      perPage: 15,
      page: 1,
      apiMode: true,
      company: {},
      actions: [
        // {
        //   btnClass: "btn-info",
        //   icon: "fa-list cwhite",
        //   callback: this.viewRawData,
        //   tooltip: "Raw Data"
        // },
      ],
      tableFields: [
        // {
        //   name: "userid",
        //   title: "UserID"
        // },
        {
          name: "first_name",
          title: "User"
        },
        {
          name: "file",
          title: "File"
        },
        {
          name: "date",
          title: "Date Time"
        }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      // current_page: 1,
      // pageToLoad: 1,
      totalPages: 1,
      // prevDisabled: 1,
      // nextDisabled: 0,
      // pages: []
    };
  },




  methods: {
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data ? {} : {};
        http.get(this.url, params, function(error, response) {
          console.log(response);
          // if (response.responseType === "success") {
            if(!myself.isFromDashBoard)
            myself.fillableData = response.data;
            else
            myself.fillableData = response.data.slice(0, 5);
            // myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            // myself.prevDisabled = myself.pageToLoad == 1;
            // myself.nextDisabled = myself.current_page == myself.totalPages;
            // myself.isLoading = false;
            // // set 5 pages to show
            // console.log("current", myself.current_page);
            // let i = 5;
            // let page = myself.current_page - 2;
            // if (page <= 0) page = 1;
            // myself.pages = [];
            // while (i) {
            //   myself.pages.push(parseInt(page));
            //   if (myself.totalPages <= page) break;
            //   page++;
            //   i--;
            // }
            myself.fillableData = myself.sorted_fields_date(myself.fillableData, 'date');
            console.log("PAges", myself.pages);
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    // prev() {
    //   this.pageToLoad = this.current_page - 1;
    //   this.$router.push({
    //     query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
    //   });
    //   this.fillTable();
    // },
    // goToPage(page) {
    //   this.pageToLoad = page;
    //   this.$router.push({
    //     query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
    //   });
    //   this.fillTable();
    // },
    // next() {
    //   console.log(this.$route.query);
    //   this.pageToLoad = this.current_page + 1;
    //   this.$router.push({
    //     query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
    //   });
    //   this.fillTable();
    // },
    // fillTable() {
    //   let url = this.apiUrl; //+"?a=1"
    //   if (this.pageToLoad != this.current_page) url += this.pageToLoad;
    //   this.url = url;
    //   this.fetchData(this.searchParams);
    // },
    pageChange(url){
      console.log("changeUrl", url);
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/activity-logs/download-history.vue